module.exports = __webpack_public_path__ + "img/landForSale.26a33478.png";